<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col lg="9" sm="12">
          <b-card-group class="row">
            <b-card no-body class="p-4 col-lg-5 col-md-5 col-sm-5 ">
              <b-card-body class="d-flex">
                <img  class="navbar-brand-full  d-md-block login-logo" src="img/logo/login-app.png"/>
              </b-card-body>
            </b-card>
            <b-card no-body class="p-4 col-lg-7 col-md-7 col-sm-7">
              <b-card-body>
                <b-form @submit.prevent="submitLogin" class="mr-2">
                  <b-input-group class="mb-3">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-envelope"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      :state="usernameState"
                      type="text"
                      placeholder="Email"
                      class="form-control"
                      autocomplete="username"
                      aria-describedby="inputUsernameFeedback"
                      v-model.trim="username">
                    </b-form-input>
                    <b-form-invalid-feedback id="inputUsernameFeedback">
                      Field is mandatory
                    </b-form-invalid-feedback>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend>
                      <b-input-group-text><i class="icon-lock"></i></b-input-group-text>
                    </b-input-group-prepend>
                    <b-form-input
                      type="password"
                      placeholder="Lozinka"
                      :state="passwordState"
                      class="form-control"
                      autocomplete="current-password"
                      aria-describedby="inputPasswordFeedback"
                      v-model="password">
                    </b-form-input>
                    <b-form-invalid-feedback id="inputPasswordFeedback">
                      Field is mandatory
                    </b-form-invalid-feedback>
                  </b-input-group>

                  <div class="action-buttons" v-if="1">
                    <b-button type="submit" style="font-size: 11px" variant="primary" class="justify-content-start">ULAZ / УЛАЗ
                    </b-button>
                    <router-link class="router-link-exact-active  nav-link public-recommendations"  :to="{name: routerName.RN_PUBLIC_RECOMMENDATION_LIST}">
                      Javne preporuke
                    </router-link>

                  </div>
                </b-form>
              </b-card-body>
            </b-card>

          </b-card-group>
        </b-col>
      </b-row>
    </div>
    <loading :show="show" :label="label" :overlay="overlay"/>
  </div>
</template>

<script>

  import routeName from '@/router/routeNames'
  import loading from 'vue-full-loading'
  import {required, minLength} from 'vuelidate/lib/validators'
  import {toast} from '@/shared/plugins/toastr'
  import routerName from '@/router/routeNames'


  export default {
    name: 'Login',
    components: {
      loading
    },
    data() {
      return {
        username: '',
        password: '',
        usernameState: null,
        passwordState: null,
        show: false,
        label: 'Logging in...',
        overlay: true,
        error: "",
        routeName,
        routerName
      }
    },
    computed: {
      errorMessage: function () {
        return this.error
      }

    },
    validations: {
      username: {
        required,
        minLength: minLength(2)
      },
      password: {
        required,
        minLength: minLength(2)
      }
    },
    methods: {
      submitLogin() {
        localStorage.clear();
        if (this.$v.username.$invalid) {
          this.usernameState = false
        }

        if (this.$v.password.$invalid) {
          this.passwordState = false
        }

        if (this.$v.$invalid) {
          return
        }

        const formData = {
          password: this.password,
          username: this.username
        }

        this.$store.dispatch('auth/actionLogin', {username: formData.username, password: formData.password})
          .then(() => {
            this.$store.dispatch('user/actionSetUser').then(() => {
              Promise.all([
                this.$store.dispatch('user/actionSetUserPermissions'),
                this.$store.dispatch('recommendation/actionSetDomains'),
                this.$store.dispatch('competentAuthority/actionSetCompetentAuthorities')
              ]).then(() => {
                this.$router.replace({name: routeName.RN_RECOMMENDATION_LIST})
                this.show = true
              }, () => {
                this.show = true
              })
            })
          })
          .catch(() => {
            this.show = false
          toast({
            'title': 'Login failed',
            'message': 'Provide the correct username and password',
            'type': 'error'
          })
        })
      }
    },
  }
</script>
<style>
.action-buttons{
  display: flex;
}
.public-recommendations{
  margin-left: auto;
}
@media (max-width: 767px) {
  .action-buttons{
    display: -webkit-box;
  }
}
</style>

